import styled from 'styled-components'

import {
  white,
  grayLight,
  grayLighter,
  gray,
  grayDark,
  grayDarker,
  blue,
} from '@bufferapp/ui/style/colors'

import Text from '~/shared/components/Text'
import { flexCol, flexRow } from '~/shared/styles/layout'
import { lila } from '~/shared/styles/colors'

export const Wrapper = styled.div`
  width: 100%;
  ${flexCol}
`

export const ButtonWrapper = styled.div`
  width: 100%;
  padding: 3px;
  background-color: ${(props) =>
    // @ts-expect-error TS(2339) FIXME: Property 'opened' does not exist on type 'ThemedSt... Remove this comment to see the full error message
    props.opened ? lila : white};
  border-radius: 5px;

  & > * {
    border: 1px solid
      ${(props) =>
        // @ts-expect-error TS(2339) FIXME: Property 'opened' does not exist on type 'ThemedSt... Remove this comment to see the full error message
        props.opened ? blue : grayLight};
  }

  &:hover > * {
    border: 1px solid
      ${(props) =>
        // @ts-expect-error TS(2339) FIXME: Property 'opened' does not exist on type 'ThemedSt... Remove this comment to see the full error message
        props.opened ? blue : grayDark};
  }
`

export const ButtonStyled = styled.div`
  width: 100%;
  height: 50px;
  ${flexRow}
  justify-content: space-between;
  border-radius: 4px;
  padding: 0px 8px;
  cursor: pointer;
  user-select: none;
  background-color: ${white};
  color: ${grayDarker};
`

export const SectionName = styled(Text)`
  padding: 8px;
`

export const ListContainer = styled.div`
  position: relative;
  width: 100%;
`

export const ListWrapper = styled.div`
  position: absolute;
  top: 2px;
  left: 0;
  z-index: 1000;
  width: 100%;
  padding: 0px 4px;
`

export const ListStyled = styled.ul`
  padding: 8px;
  background-color: ${white};
  border: 1px solid ${gray};
  box-shadow: 0px 1px 4px rgba(0, 0, 0, 0.16);
  border-radius: 4px;
`

export const ListItem = styled.li`
  width: 100%;
  list-style: none;
  user-select: none;
  cursor: ${(props) =>
    // @ts-expect-error TS(2339) FIXME: Property 'clickable' does not exist on type 'Theme... Remove this comment to see the full error message
    props.clickable ? 'pointer' : 'default'};
  padding: 6px 8px;
  background-color: ${white};
  border-radius: 5px;

  &:hover {
    background-color: ${grayLighter};
  }
`
